var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.displayLoading ? _c('div', [_c('Loading')], 1) : _vm._e(), _c('div', {
    staticClass: "page"
  }, [_vm.getModuleConfig('validate_page.step_section.enable_step_section') ? _c('div', {
    staticClass: "p-3"
  }, [_c('SharedStep', {
    attrs: {
      "steps": _vm.getModuleConfig('validate_page.step_section.steps')
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("validate_page.form_title")) + " ")]), _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("validate_page.form_desc")) + " ")]), _c('div', {
    staticClass: "page__desc__text"
  }, [_vm._v(" " + _vm._s(_vm.trans('sms_code_send_to', '簡訊驗證碼已發送至'))), _c('b', {
    staticClass: "google-sans-code"
  }, [_vm._v(_vm._s(_vm.mobile))]), _vm._v("，"), _c('br'), _vm.counter ? _c('div', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.counterMessage)
    }
  })]) : _c('div', [_vm._v(" " + _vm._s(_vm.trans('expired_sms_code', '驗證碼已失效，請重新驗證。')) + " ")])]), _c('div', {
    staticClass: "code-input"
  }, [_c('CodeInput', {
    key: _vm.codeInputKey,
    ref: "codeInput",
    staticClass: "google-sans-code",
    class: {
      invalid: !_vm.isValid
    },
    attrs: {
      "loading": false,
      "fields": _vm.verifyCodeLength,
      "fieldHeight": 80
    },
    on: {
      "change": _vm.onChange
    }
  }), !_vm.isValid ? _c('div', {
    staticClass: "form__error-msg"
  }, [_vm._v(" " + _vm._s(_vm.trans('wrong_sms_code', '驗證碼有誤，請再次確認')) + " ")]) : _vm._e()], 1), _c('div', {
    staticClass: "page__bottom"
  }, [_vm._v(" " + _vm._s(_vm.trans('not_receive', '沒收到嗎？'))), _c('span', {
    on: {
      "click": _vm.handleResend
    }
  }, [_vm._v(_vm._s(_vm.trans('send_sms_code_again', '重新發送驗證碼')))])]), _c('div', {
    staticClass: "page__bottom"
  }, [_vm._v(" " + _vm._s(_vm.trans('wrong_mobile_phone', '手機號碼錯誤？'))), _c('span', {
    on: {
      "click": _vm.handleReturn
    }
  }, [_vm._v(_vm._s(_vm.trans('refill_data', '重新填寫資料')))])])]), _c('div', {
    staticClass: "page__button"
  }, [_c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("validate_page.button_text") || '送出') + " ")])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }